import { Box, Skeleton } from '@mui/material';
import {
  GeneralPatientInfoBlock,
  GeneralPatientInfoBlockWrapper,
  PatientActionsWrapper,
  PatientEmail,
  PatientName
} from './general-patient-info.styles';

export const GeneralPatientInfoSkeleton = () => {
  return (
    <GeneralPatientInfoBlockWrapper>
      <GeneralPatientInfoBlock>
        <PatientName>
          <Skeleton variant="text" sx={{ width: '60px', height: '24px', marginRight: '8px' }} />
          <Skeleton variant="text" sx={{ width: '100px', height: '24px', marginRight: '8px' }} />
          <Skeleton variant="text" sx={{ width: '20px', height: '24px' }} />
        </PatientName>
        <Box sx={{ display: 'flex', margin: '2px 2px 2px 5px', alignItems: 'center' }}>
          <Skeleton variant="text" sx={{ width: '60px', height: '18px', marginRight: '6px' }} />
          <Skeleton variant="circular" sx={{ width: '7px', height: '7px', marginRight: '6px' }} />
          <Skeleton variant="text" sx={{ width: '75px', height: '18px' }} />
        </Box>
        <PatientEmail>
          <Skeleton variant="text" sx={{ width: '130px', height: '18px' }} />
        </PatientEmail>
      </GeneralPatientInfoBlock>
      <PatientActionsWrapper>
        <Skeleton variant="circular" sx={{ width: '48px', height: '48px' }} />
      </PatientActionsWrapper>
    </GeneralPatientInfoBlockWrapper>
  );
};
